import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import { faUndo, faEye, faDownload, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import "bootstrap/dist/css/bootstrap.css";
import apiUrl from "../../apiUrlConstant";
import { Redirect, withRouter, Link } from "react-router-dom";
import SimpleReactValidator from "simple-react-validator";
import axios from "axios";
import Select, {
  components,
  MultiValueGenericProps,
  MultiValueProps,
  OnChangeValue,
  Props,
} from "react-select";

import RevenueTable from "./RevenueTable";

import * as Yup from "yup";
import { type } from "jquery";
import { getUserType, fileUploadPath } from "../../utils/index";

if (getUserType() == "Landlord") {
  var reportFilterForm = Yup.object().shape({
    // assetId: Yup.string().required("Required"),
    // leaseId: Yup.number().required("Required"),
    financialYearOne: Yup.string().required("Required"),
    financialYearTwo: Yup.string().required("Required"),

    //stateId: Yup.string().required("Required"),
    //districtId: Yup.string().required("Required"),
    //cityId: Yup.string().required("Required"),
  });
} else if (getUserType() == "Occupier") {
  var reportFilterForm = Yup.object().shape({
    // brandId: Yup.number().required("Required"),
    // leaseId: Yup.number().required("Required"),
    financialYearOne: Yup.string().required("Required"),
    financialYearTwo: Yup.string().required("Required"),

    // stateId: Yup.string().required("Required"),
    // districtId: Yup.string().required("Required"),
    // cityId: Yup.string().required("Required"),
  });
} else {
  var reportFilterForm = Yup.object().shape({
    // leaseId: Yup.number().required("Required"),
    financialYearOne: Yup.string().required("Required"),
    financialYearTwo: Yup.string().required("Required"),
  });
}

const ClearButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  columns={columns}
  height: 34px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color:#003970;
`;
//const [selectedValue, setSelectedValue] = useState([]);

let monthsArr = [];
var i = 0;
for (; i <= 12; i++) {
  monthsArr.push({ id: i, value: i });
}

let financialYear = [];
// var i = 0;  let currentYear = new Date().getFullYear();
// financialYear.push({ id: (currentYear + 1) , value: (currentYear )  + "-" + (currentYear + 1) })
// for (; i <= 10; i++) {
//   financialYear.push({ id: currentYear , value: (currentYear - 1)  + "-" + currentYear });
//   --currentYear;
// }

const uploadFromFrm = Yup.object().shape({
  myfile: Yup.string().required("Required"),
});


var tableCounter = 0;
const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};
class FinanceInput extends React.Component {
  groupId = { value: "" };
  state = {
    exportBtn: false,
    selectedFile: '',
    chargeTypeSelected: [],
    brandSelected: [],
    landloardList: [],
    occupierList: [],
    selectedValue: [],
    setSelectedValue: [],
    leaseSelected: [],
    countries: [],
    monthsArr: [],
    districtList: [],
    cityList: [],
    brandCatList: [],
    brandList: [],
    financialYear: [],
    assetsList: [],
    assetTypeList: [],
    assetTypeSelected: [],
    redirect: false,
    states: [],
    landloardCompanyList: [],
    financialYearOne: "",
    financialYearTwo: "",

    id: undefined,
    selectedBrand: "",
    counter: 0,
    selectedAsset: "",

    leaseList: [],
    formResponseData: [],
    formResponseData1: {
      forecasteDetails: {
        forecast: [],
        actual: [],
      },
    },
    initialForecast: {},
    leaseType: "",
    leaseTypes: [],
    initialValues: {
      brandId: [],
      countryId: "",
      stateId: "",
      districtId: "",
      cityId: "",
      landloardName: "",
      landloardId: "",
      OccupierName: "",
      occupierId: "",
      brandCatId: "",
      brandName: [],
      leaseId: "",
      chargeTypeSelected: [],
      financialYear: "",
      chargeType: "",
      financialYearOne: "Period 1",
      financialYearTwo: "Period 2",
      landloardCompanyName: "",
      landloardCompanyId: "",
      leaseType: "",
      modelValue: 'All',
      modelId: 'All',
      assetTypeId: "",
    },
  };

  componentDidMount() {
    this.initialiseAllData();
    
  }

  componentDidUpdate() { }

  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  }

  initialiseAllData = () => {
    fetch(`${apiUrl.apiUrl.url}/countries`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/brand/get-all-brands`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          brandList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/lease-report/get-lease-status`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          leaseStatus: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/lease-report/get-occupier-landloard`, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          landloardList: data.landloardList,
          occupierList: data.occupierList,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/lease-report/fetch-lease-types`, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          leaseTypes: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    this.getAssetsList("", "", true);
    this.getAssetTypes();
  }

  getAssetTypes = () => {
    let self = this;
    axios({
      method: 'GET',
      url: `${apiUrl.apiUrl.url}/unit-detail/get-asset-types-with-filters?city_id=${this.state.initialValues.cityId}&brand_ids=${this.state.initialValues.brandId}
      `,
      headers: headers
    }).then((response) => {
      self.setState({
        assetTypeList: response.data
      });
    });
  }

  getAssetsListByAssetType = () => {
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("TOKEN"),
    };

    fetch(
      `${apiUrl.apiUrl.url}/unit-detail/get-asset-types-asset-lists?asset_type_ids=
      ${this.state.initialValues.assetTypeId}&city_id=${this.state.initialValues.cityId}&brand_ids=${this.state.initialValues.brandId}`,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          assetsList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getAssetsList = (input, e, cust) => {
    if (
      (typeof e != "undefined" && e.action == "input-change") ||
      cust === true
    ) {
      fetch(
        `${apiUrl.apiUrl.url}/unit-detail/get-all-assets?city_id=` +
        this.state.initialValues.cityId +
        `&assetName=` +
        input,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("data", data);
          this.setState({
            assetsList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  setMasterPreValues = (input) => {
    fetch(
      `${apiUrl.apiUrl.url}/unit-detail/get-select-asset-details?assetId=` +
      input,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data.countries,
          districtList: data.district,
          states: data.state,
          cityList: data.cities,
        });
        this.state.initialValues.stateId = data.data.stateId.stateId;
        this.state.initialValues.state_name = data.data.stateId.state_name;
        this.state.initialValues.cityId = data.data.cityId.cityId;
        this.state.initialValues.cityName = data.data.cityId.cityName;
        this.state.initialValues.districtId = data.data.districtId.districtId;
        this.state.initialValues.districtName =
          data.data.districtId.districtName;
        this.state.initialValues.countryId = data.data.countryId.countryId;
        this.state.initialValues.countryName = data.data.countryId.countryName;
        if (
          this.state.initialValues.brandId.length == 0 ||
          this.state.initialValues.brandId == ""
        ) {
          this.state.initialValues.brandCatId = data.data.catId;
          this.state.initialValues.brandCatName = data.data.cat_name;
          this.state.brandList = data.brandList;
          this.state.brandSelected = [
            { value: data.data.brandId, label: data.data.brand_name },
          ];
          // this.state.initialValues.brandId = [data.data.brandId];
        }
        this.setState({});
      })
      .catch((error) => {
        console.log(error);
      });
  };

  valueChange = (newValue, actionMeta) => {
    console.log("newVa calling..", newValue, "meta", actionMeta);

    //newValue.value = newValue.target.value;
    //newValue.label = newValue.target.value;

    if (actionMeta == "change_state") {
      this.state.initialValues.stateId = newValue.value;
      this.state.initialValues.state_name = newValue.label;

      this.state.initialValues.districtId = "";
      this.state.initialValues.districtName = "";
      this.state.initialValues.cityId = "";
      this.state.initialValues.cityName = "";

      this.state.initialValues.assetId = "";
      this.state.initialValues.assetName = "";

      fetch(
        `${apiUrl.apiUrl.url}/district/state-districts?state_id=` +
        newValue.value, {headers}
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            districtList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });

      //districtList
    } else if (actionMeta == "change_district") {
      this.state.initialValues.districtId = newValue.value;
      this.state.initialValues.districtName = newValue.label;

      this.state.initialValues.cityId = "";
      this.state.initialValues.cityName = "";

      fetch(`${apiUrl.apiUrl.url}/cities/district-cities/` + newValue.value, {headers})
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            cityList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_lease_type") {
      this.state.initialValues.modelId = newValue.value;
      this.state.initialValues.modelValue = newValue.label;

      fetch(
        `${apiUrl.apiUrl.url}/lease-view/get-lease-list?all=true&brand=` +
        this.state.initialValues.brandId +
        "&asset=" +
        this.state.initialValues.assetId +
        "&brandCategory=" +
        this.state.initialValues.brandCatId + "&modelType=" + this.state.initialValues.modelId,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            leaseList: data,
          });

          this.state.initialValues.leaseValue = "";
          this.state.initialValues.leaseId = "";
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_lease_number") {
      //change_document_type

      this.state.leaseSelected = [];
      if (newValue.length == 0) {
        this.state.initialValues.leaseId = "";
      } else {
        this.state.initialValues.leaseId = [];
      }
      if (newValue.length > 0 && newValue[0].value == 0) {
        this.state.leaseSelected.push({
          value: newValue[0].value,
          label: newValue[0].label,
        });

        for (let i = 0; i < this.state.leaseList.length; i++) {
          if (this.state.leaseList[i].id != 0) {
            this.state.initialValues.leaseId.push(this.state.leaseList[i].id);
          }
        }
      } else {
        for (let i = 0; i < newValue.length; i++) {
          this.state.initialValues.leaseId.push(newValue[i].value);
          this.state.selectedValue.push(newValue[i].value);
          this.state.leaseSelected.push({
            value: newValue[i].value,
            label: newValue[i].label,
          });
        }
      }

    } else if (actionMeta == "brand_category") {
      this.state.initialValues.brandCatId = newValue.value;
      this.state.initialValues.brandCatName = newValue.label;
      this.state.initialValues.brandId = [];
      this.state.initialValues.brandName = [];
      //get-brand-subcategory/?id=
      fetch(
        `${apiUrl.apiUrl.url}/brand/get-brand-by-category?cat_id=` +
        newValue.value,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            brandList: data,
          });

          this.state.brandSelected = [];
          this.state.initialValues.brandId = ["0"];
          this.state.brandSelected.push({ value: 0, label: "All" });

          for (let i = 0; i < data.length; i++) {
            this.state.initialValues.brandId.push(data[i].id);
          }

          console.log(
            this.state.initialValues.brandId,
            "this.state.initialValues.brandId"
          );
          this.setState({});

          this.getAssetsListByBrand();
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_city") {

      // unset asset type and asset name
      this.state.assetTypeSelected = [];
      this.state.initialValues.assetTypeId = [];
      this.state.assetsList = [];
      this.state.initialValues.assetName ="";
      this.state.initialValues.assetId ="";
      this.getAssetTypes();

      //brandName
      this.state.initialValues.cityId = newValue.value;
      this.state.initialValues.cityName = newValue.label;

      fetch(
        `${apiUrl.apiUrl.url}/unit-detail/get-all-assets?city_id=` +
        newValue.value,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("data", data);
          this.setState({
            assetsList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_lease_status") {
      //brandName
      this.state.initialValues.LeaseStatusId = newValue.value;
      this.state.initialValues.LeaseStatusName = newValue.label;
    } else if (actionMeta == "change_brand") {

      // unset asset type and asset name
      this.state.assetTypeSelected = [];
      this.state.initialValues.assetTypeId = [];
      this.state.assetsList = [];
      this.state.initialValues.assetName ="";
      this.state.initialValues.assetId ="";

      this.state.brandSelected = [];
      this.state.initialValues.brandId = [];
      for (let i = 0; i < newValue.length; i++) {
        this.state.initialValues.brandId.push(newValue[i].value);
        this.state.brandSelected.push({
          value: newValue[i].value,
          label: newValue[i].label,
        });
      }

      this.getAssetsListByBrand();
      this.getAssetTypes();

      fetch(
        `${apiUrl.apiUrl.url}/lease-view/get-lease-list?all=true&brand=` +
        this.state.initialValues.brandId +
        "&asset=" +
        this.state.initialValues.assetId +
        "&brandCategory=" +
        this.state.initialValues.brandCatId + "&modelType=" + this.state.initialValues.modelId,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            leaseList: data,
          });

          this.state.initialValues.leaseValue = [];
          this.state.initialValues.leaseId = [];
        })
        .catch((error) => {
          console.log(error);
        });

      console.log(this.state.initialValues, "this.state.initialValues");
    } else if (actionMeta == "change_asset_type") {

      this.state.initialValues.assetName ="";
      this.state.initialValues.assetId ="";

      this.state.assetTypeSelected = [];
      this.state.initialValues.assetTypeId = [];
      for (let i = 0; i < newValue.length; i++) {
        this.state.initialValues.assetTypeId.push(newValue[i].value);
        this.state.assetTypeSelected.push({
          value: newValue[i].value,
          label: newValue[i].label,
        });
      }

      this.getAssetsListByAssetType();

    } else if (actionMeta == "change_asset_name") {
      //change_lease_month
      this.state.initialValues.assetId = newValue.value;
      this.state.initialValues.assetName = newValue.label;
      this.setMasterPreValues(newValue.value);
      fetch(
        `${apiUrl.apiUrl.url}/lease-view/get-revenue-lease-list?all=true&brand=` +
        this.state.initialValues.brandId +
        "&asset=" +
        this.state.initialValues.assetId +
        "&brandCategory=" +
        this.state.initialValues.brandCatId +
        "&leaseType=" + this.state.leaseType + "&modelType=" + this.state.initialValues.modelId,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            leaseList: data,
          });

          this.state.initialValues.leaseValue = [];
          this.state.initialValues.leaseId = [];
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_charge_type") {
      this.state.initialValues.chargeTypeSelected = [];
      this.state.chargeTypeSelected = [];
      for (let i = 0; i < newValue.length; i++) {
        this.state.initialValues.chargeTypeSelected.push(newValue[i].value);
        this.state.chargeTypeSelected.push({
          value: newValue[i].value,
          label: newValue[i].label,
        });
      }
    } else if (actionMeta == "change_financial_yearone") {
      //change_lease_month
      this.state.initialValues.financialYearIdOne = newValue.value;
      this.state.initialValues.financialYearOne = newValue.label;
    } else if (actionMeta == "change_financial_yeartwo") {
      //change_lease_month
      this.state.initialValues.financialYearIdTwo = newValue.value;
      this.state.initialValues.financialYearTwo = newValue.label;
    } else if (actionMeta == "change_lease_month") {
      //change_lease_month
      this.state.initialValues.leaseMonthId = newValue.value;
      this.state.initialValues.leaseMonthId = newValue.label;
    } else if (actionMeta == "change_occupier") {
      //brandName
      this.state.initialValues.occupierId = newValue.value;
      this.state.initialValues.occupierName = newValue.label;
    } else if (actionMeta == "change_landloard_company") {
      this.state.initialValues.landloardCompanyId = newValue.value;
      this.state.initialValues.landloardCompanyName = newValue.label;
    } else if (actionMeta == "lease_type") {
      this.state.initialValues.leaseType = newValue;
      this.state.leaseType = newValue.label;
      fetch(
        `${apiUrl.apiUrl.url}/lease-view/get-revenue-lease-list?all=true&brand=` +
        this.state.initialValues.brandId +
        "&asset=" +
        this.state.initialValues.assetId +
        "&brandCategory=" +
        this.state.initialValues.brandCatId +
        "&leaseType=" + newValue.label + "&modelType=" + this.state.initialValues.modelId,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            leaseList: data,
          });

          this.state.initialValues.leaseValue = [];
          this.state.initialValues.leaseId = [];
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (actionMeta == "change_landloard") {
      //brandName
      this.state.initialValues.landloardId = newValue.value;
      this.state.initialValues.landloardName = newValue.label;

      //
      fetch(
        `${apiUrl.apiUrl.url}/landlord/get-group-companies/?id=` +
        newValue.value,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.setState({
            landloardCompanyList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      this.state.initialValues.countryId = newValue.value;
      this.state.initialValues.countryName = newValue.label;
    }
    this.setState({});
  };

  getAssetsListByBrand = () => {
    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("TOKEN"),
    };

    fetch(
      `${apiUrl.apiUrl.url}/unit-detail/get-brand-asset-list?brandId=` +
      this.state.initialValues.brandId,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          assetsList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(
      `${apiUrl.apiUrl.url}/lease-view/get-lease-list?all=true&brand=` +
      this.state.initialValues.brandId +
      "&asset=" +
      this.state.initialValues.assetId +
      "&brandCategory=" +
      this.state.initialValues.brandCatId + "&modelType=" + this.state.initialValues.modelId,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          leaseList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleChangeCountry = (newValue, actionMeta) => {
    console.log(newValue.value, "jj");
    this.countryId = newValue.value;
    newValue.label = newValue.label;

    if (newValue.value == "") {
      console.log("country value empty");
      this.state.states = [];
    }

    this.state.initialValues.countryId = newValue.value;
    this.state.initialValues.countryName = newValue.label;

    this.state.initialValues.stateId = "";
    this.state.initialValues.stateName = "";
    this.state.initialValues.districtId = "";
    this.state.initialValues.districtName = "";
    this.state.initialValues.cityId = "";
    this.state.initialValues.cityName = "";

    fetch(`${apiUrl.apiUrl.url}/states/country-states/` + this.countryId, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          states: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleChangeClientGroup = (newValue, actionMeta) => {
    console.group("Value Changed", newValue, "actionmeta", actionMeta);
    this.state.initialValues.groupId = newValue.value;
    this.state.initialValues.groupName = newValue.label;
    this.setState({});
    console.log(newValue, "ddd");
    console.log(`action: ${actionMeta}`);
    console.groupEnd();
  };

  onFileChange = (event) => {
    // Update the state
    this.setState({ selectedFile: event.target.files[0] });
  };

  cancelForm = () => {
    this.setState({ exportBtn: false });
  }

  onFileUpload = () => {
    // Create an object of formData
    const formData = new FormData();

    console.log(formData, "formData", this.state.selectedFile);

    if (typeof this.state.selectedFile == "undefined" || typeof this.state.selectedFile.name == "undefined") {
      alert("Please upload file to process");
      return true;
    }

    var ths = this;

    // Update the formData object
    formData.append(
      "myFile",
      this.state.selectedFile,
      this.state.selectedFile.name
    );

    //formData.append("dateAsOn", this.state.initialValues.dateAsOn);

    // Request made to the backend api
    // Send formData object
    axios
      .post(`${apiUrl.apiUrl.url}/finance-report/yes-first-report-upload?date=${this.state.formConfig.financialYearOne}`, formData)
      .then(function (response) {
        console.log(response, "response");
        if (response.data.success) {
          alert("Form processed successfully.");
          ths.setState({ exportBtn: false });
        }
      });
  };

  formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };

  handleCalenderOnBlur = () => {
    this.state.initialValues.financialYearOne = this.formatDate(
      this.state.financialYearOne
    );
    this.state.initialValues.financialYearTwo = this.formatDate(
      this.state.financialYearTwo
    );
  };
  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/masters/client-profile" />;
    }
    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>Finance</li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <a href="#">
                  Input File
                </a>
              </li>
            </ul>
          </div>
        </div>

        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          validationSchema={reportFilterForm}
          onReset={(values, actions) => {
            this.state.brandSelected = [];
            for (const [key, value] of Object.entries(
              this.state.initialValues
            )) {
              this.state.initialValues[key] = "";
            }
            this.state.leaseSelected = [];
            this.state.initialValues.chargeTypeSelected = [];
            this.state.chargeTypeSelected = [];
            this.state.financialYearOne = "";
            this.state.financialYearTwo = "";
            this.state.counter = Math.random();
            this.setState({});
            
            this.state.assetTypeSelected = [];
            this.state.initialValues.assetTypeId = [];
            this.initialiseAllData();
          }}
          onSubmit={(values, actions) => {
            if (!this.validator.allValid()) {
              this.validator.showMessages();
              return false;
            }
            values.groupId = this.state.initialValues.groupId;

            var brand_id = this.state.initialValues.brandId;
            var asset_id = this.state.initialValues.assetId;
            var form_config = this.state.initialValues;

            form_config.expiry_status = true;

            var counter = this.state.counter + 1;
            var ths = this;

            this.setState({ selectedBrand: brand_id });
            this.setState({ selectedAsset: asset_id });
            this.setState({ formConfig: form_config });
            var prm = Object.entries(form_config)
              .map(([key, val]) => `${key}=${val}`)
              .join("&");
            this.state.formResponseData = [];
            var headers = {
              "Content-Type": "application/json",
              Authorization: "Bearer " + localStorage.getItem("TOKEN"),
            };
            // fetch(
            //   `${apiUrl.apiUrl.url}/finance-report/yes-first-report-download?` + prm,
            //   { headers }
            // )
            //   .then((response) => {
            //     //return response.json();
            //     console.log(response, "response")
            //     ths.setState({ exportBtn: true });
            //     // window.location.href = `${apiUrl.apiUrl.url + '/lease-report/download-file?path=' + response}`;
            //   })
            //   .catch((error) => {
            //     console.log(error,"response eroor");
            //   });

              axios({
                method: "post",
                url: `${apiUrl.apiUrl.url}/finance-report/yes-first-report-download?` + prm,
                //data: { columnsList: columnsList }
              }).then(function (response) {
                ths.setState({ exportBtn: true });
                window.location.href = `${apiUrl.apiUrl.url + '/lease-report/download-file?path=' + response.data}`;
              });

            form_config = undefined;
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <>
              <div className="unitFormContainerNew">
                <Form autoComplete="off" >
                  <div className="newGridSectionParent">
                    <div className="newGridSectionForFormMain">

                      <div className="newGridSectionInner">
                        <label>Country</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="countryId"
                            isSearchable="true"
                            onChange={(e) => {
                              this.handleChangeCountry(e, "changecountry");
                            }}
                            value={{
                              label: this.state.initialValues.countryName,
                              value: this.state.initialValues.countryId,
                            }}
                            options={this.state.countries.map((item) => ({
                              label: item.country_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage name="countryId" component="div" className="text-red" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Charge Type</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            isMulti
                            onChange={(e) => {
                              this.valueChange(e, "change_charge_type");
                            }}
                            value={this.state.chargeTypeSelected}
                            name="chargeType"
                            options={[
                              "ALL",
                              "CAM",
                              "RENT",
                              "Other Rent Details",
                              "Property Tax",
                              "Marketing Fund",
                              "Parking 2W",
                              "Parking 4W",
                              "Parking Other",
                              "Storage",
                              "Signage",
                            ].map((item) => ({
                              label: item,
                              value: item,
                            }))}
                          />
                          {this.validator.message(
                            "chargeType",
                            this.state.chargeTypeSelected,
                            "required",
                            { className: "text-danger" }
                          )}
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>State</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="stateId"
                            onChange={(e) => {
                              this.valueChange(e, "change_state");
                            }}
                            value={{
                              label: this.state.initialValues.state_name,
                              value: this.state.initialValues.state_id,
                            }}
                            options={this.state.states.map((item) => ({
                              label: item.state_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage name="stateId" component="div" className="text-red" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Brand Name</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="brandId"
                            isMulti
                            closeMenuOnSelect={true}
                            onInputChange={this.handleChange}
                            onChange={(e) => {
                              this.valueChange(e, "change_brand");
                            }}
                            value={this.state.brandSelected}
                            options={this.state.brandList.map((item) => ({
                              label: item.brand_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage name="brandId" component="div" className="text-red" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>District</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="districtId"
                            onChange={(e) => {
                              this.valueChange(e, "change_district");
                            }}
                            value={{
                              label: this.state.initialValues.districtName,
                              value: this.state.initialValues.districtId,
                            }}
                            options={this.state.districtList.map((item) => ({
                              label: item.district_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage name="districtId" component="div" className="text-red" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Asset Type</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="assetId"
                            isMulti
                            onInputChange={this.handleChange}
                            onChange={(e) => {
                              this.valueChange(e, "change_asset_type");
                            }}
                            value={this.state.assetTypeSelected}
                            options={this.state.assetTypeList.map((item) => ({
                              label: item.name,
                              value: item.id,
                            }))}
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>City</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="cityId"
                            onChange={(e) => {
                              this.valueChange(e, "change_city");
                            }}
                            value={{
                              label: this.state.initialValues.cityName,
                              value: this.state.initialValues.cityId,
                            }}
                            options={this.state.cityList.map((item) => ({
                              label: item.city_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage name="cityId" component="div" className="text-red" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Asset Name</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="assetId"
                            onInputChange={this.getAssetsList}
                            onChange={(e) => {
                              this.valueChange(e, "change_asset_name");
                            }}
                            value={{
                              label: this.state.initialValues.assetName,
                              value: this.state.initialValues.assetId,
                            }}
                            options={this.state.assetsList.map((item) => ({
                              label: item.asset_name,
                              value: item.id,
                            }))}
                          />
                          {this.validator.message(
                            "Asset Name",
                            this.state.initialValues.assetId,
                            "required",
                            { className: "text-danger" }
                          )}
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Lease Type</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            onChange={(e) => {
                              this.valueChange(e, "lease_type");
                            }}
                            value={this.state.initialValues.leaseType}
                            name="leaseType"
                            options={[
                              "ALL",
                              "Active",
                              "Expired",
                              "Terminated"
                            ].map((item) => ({
                              label: item,
                              value: item,
                            }))}
                          />
                          {this.validator.message(
                            "leaseType",
                            this.state.leaseType,
                            "required",
                            { className: "text-danger" }
                          )}
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Model Type</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="modelType"
                            onChange={(e) => {
                              this.valueChange(e, "change_lease_type");
                            }}
                            value={{
                              label: this.state.initialValues.modelValue,
                              value: this.state.initialValues.modelId,
                            }}
                            options={this.state.leaseTypes.map((item) => ({
                              label: item.value,
                              value: item.label,
                            }))}
                          />
                          <ErrorMessage name="modelType" component="div" className="text-red" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Lease Number</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="leaseId"
                            isMulti
                            onInputChange={this.handleChange}
                            onChange={(e) => {
                              this.valueChange(e, "change_lease_number");
                            }}
                            value={this.state.leaseSelected}
                            options={this.state.leaseList.map((item) => ({
                              label: item.lease_code,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage name="leaseId" component="div" className="text-red" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Cost Center/ Branch Code </label>
                        <div className="position-relative">
                          <input
                            className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                            name="costcenter"
                            onChange={(e) => {
                              this.state.initialValues.costCenter = e.target.value;
                              this.setState({});
                            }}
                          />
                          <ErrorMessage name="costCenter" component="div" className="text-red" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Charge Month</label>
                        <div className="position-relative">
                          <DatePicker
                            onChange={(date) =>
                              this.setState({ financialYearOne: date })
                            }
                            onBlur={this.handleCalenderOnBlur}
                            dateFormat="MMMM yyyy"
                            showMonthYearPicker
                            placeholderText="Month From"
                            selected={this.state.financialYearOne}
                            onCalendarClose={this.handleCalenderOnBlur}
                            maxDate={this.state.financialYearTwo}
                          />
                          {this.validator.message(
                            "Period",
                            this.state.financialYearOne,
                            "required",
                            { className: "text-danger" }
                          )}
                        </div>
                      </div>

                    </div>
                    <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                      <button type="submit" className="add_button">
                        Download
                      </button>
                      <button type="reset" className="reset_button" >
                        Reset
                      </button>
                    </div>
                  </div>
                </Form>
              </div>
            </>
          )}
        </Formik>
        {this.state.exportBtn && (
          <Formik
            validationSchema={uploadFromFrm}
            initialValues={this.state.initialValues}
            enableReinitialize
            onSubmit={(values, actions) => {
              values.leaseDocumentUrl =
                fileUploadPath() +
                this.props.match.params.id +
                "/" +
                this.state.fileName;
              console.log(values);
              var self = this;
            }}
          >
            {({
              values,

              errors,

              touched,

              handleChange,

              handleBlur,

              handleSubmit,

              isSubmitting,
            }) => (
              <Form autoComplete="off" className="customTabs">
                <div className="unitFormContainer leaseSection utilities">
                  <div className="container">

                    <div className="row">
                      <div className="col-lg-6">
                        <div className="inputContainer customFileUpload col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <div className="col-sm-4">
                              <h6>
                                Upload Input File
                                <span className="astrik">*</span>
                              </h6>
                            </div>
                            <div className="col-sm-7">
                              <Field
                                name="myfile"
                                type="file"
                                onChange={this.onFileChange}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end btnContainer">
                      <div>
                        <button onClick={this.onFileUpload} className="add_button">Upload</button>

                        <button type="reset" className="reset_button" onClick={this.cancelForm}>
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="container utilities">
                  <div className="row">
                    <div className="tableContainer"></div>
                  </div>
                  <div className="row"></div>
                </div>
              </Form>
            )}
          </Formik>
        )}

      </>
    );
  }
}

export default withRouter(FinanceInput);
